export default __webpack_public_path__ + "static/media/Cappucino - proportioned_170.9f888484.jpg";